// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_water_kind_enum */
var InvWaterKindEnum;
(function (InvWaterKindEnum) {
    InvWaterKindEnum["TAP"] = "TAP";
    InvWaterKindEnum["DI"] = "DI";
    InvWaterKindEnum["STERILIZED"] = "STERILIZED";
    InvWaterKindEnum["ULTRAPURE"] = "ULTRAPURE";
    InvWaterKindEnum["FILTER_STERILIZED"] = "FILTER_STERILIZED";
    InvWaterKindEnum["UHT"] = "UHT";
})(InvWaterKindEnum || (InvWaterKindEnum = {}));
;
export default InvWaterKindEnum;
/** Zod schema for inv_water_kind_enum */
export const invWaterKindEnum = z.nativeEnum(InvWaterKindEnum);
//# sourceMappingURL=InvWaterKindEnum.js.map